module.exports = __webpack_public_path__ + "img/c05_unittechliburnianchampion_Normal_ua.1ce64a9b.webp";